import { NgModule } from 'ng-metadata/core';
import { MiniModalDialogComponent } from './mini-modal/mini-modal.dialog.component';
import { configureMdDialogProvider } from './md-dialog-provider.config';
import './dialog.scss';
import { FlexiModalHeaderComponent } from './flexi-modal/header/flexi-modal-header.component';

/**
 * @ngdoc module
 * @name mw.components.dialog
 * @description
 *
 * Dialogs
 */
@NgModule({
    declarations: [ MiniModalDialogComponent, FlexiModalHeaderComponent ],
    providers: [configureMdDialogProvider],
    imports: ['ngSanitize']
})
export class DialogModule {}




// WEBPACK FOOTER //
// ./src/lib/components/dialog/dialog.module.ts